export const ICHI_NEN_KANJI = 
[
  {
      "Gakunen": "1",
      "Num": "1",
      "Kanji": "人"
  },
  {
      "Gakunen": "1",
      "Num": "2",
      "Kanji": "一"
  },
  {
      "Gakunen": "1",
      "Num": "3",
      "Kanji": "七"
  },
  {
      "Gakunen": "1",
      "Num": "4",
      "Kanji": "三"
  },
  {
      "Gakunen": "1",
      "Num": "5",
      "Kanji": "上"
  },
  {
      "Gakunen": "1",
      "Num": "6",
      "Kanji": "下"
  },
  {
      "Gakunen": "1",
      "Num": "7",
      "Kanji": "中"
  },
  {
      "Gakunen": "1",
      "Num": "8",
      "Kanji": "九"
  },
  {
      "Gakunen": "1",
      "Num": "9",
      "Kanji": "二"
  },
  {
      "Gakunen": "1",
      "Num": "10",
      "Kanji": "五"
  },
  {
      "Gakunen": "1",
      "Num": "11",
      "Kanji": "休"
  },
  {
      "Gakunen": "1",
      "Num": "12",
      "Kanji": "先"
  },
  {
      "Gakunen": "1",
      "Num": "13",
      "Kanji": "入"
  },
  {
      "Gakunen": "1",
      "Num": "14",
      "Kanji": "八"
  },
  {
      "Gakunen": "1",
      "Num": "15",
      "Kanji": "六"
  },
  {
      "Gakunen": "1",
      "Num": "16",
      "Kanji": "円"
  },
  {
      "Gakunen": "1",
      "Num": "17",
      "Kanji": "出"
  },
  {
      "Gakunen": "1",
      "Num": "18",
      "Kanji": "力"
  },
  {
      "Gakunen": "1",
      "Num": "19",
      "Kanji": "十"
  },
  {
      "Gakunen": "1",
      "Num": "20",
      "Kanji": "千"
  },
  {
      "Gakunen": "1",
      "Num": "21",
      "Kanji": "口"
  },
  {
      "Gakunen": "1",
      "Num": "22",
      "Kanji": "右"
  },
  {
      "Gakunen": "1",
      "Num": "23",
      "Kanji": "名"
  },
  {
      "Gakunen": "1",
      "Num": "24",
      "Kanji": "四"
  },
  {
      "Gakunen": "1",
      "Num": "25",
      "Kanji": "土"
  },
  {
      "Gakunen": "1",
      "Num": "26",
      "Kanji": "夕"
  },
  {
      "Gakunen": "1",
      "Num": "27",
      "Kanji": "大"
  },
  {
      "Gakunen": "1",
      "Num": "28",
      "Kanji": "天"
  },
  {
      "Gakunen": "1",
      "Num": "29",
      "Kanji": "女"
  },
  {
      "Gakunen": "1",
      "Num": "30",
      "Kanji": "子"
  },
  {
      "Gakunen": "1",
      "Num": "31",
      "Kanji": "字"
  },
  {
      "Gakunen": "1",
      "Num": "32",
      "Kanji": "学"
  },
  {
      "Gakunen": "1",
      "Num": "33",
      "Kanji": "小"
  },
  {
      "Gakunen": "1",
      "Num": "34",
      "Kanji": "山"
  },
  {
      "Gakunen": "1",
      "Num": "35",
      "Kanji": "川"
  },
  {
      "Gakunen": "1",
      "Num": "36",
      "Kanji": "左"
  },
  {
      "Gakunen": "1",
      "Num": "37",
      "Kanji": "年"
  },
  {
      "Gakunen": "1",
      "Num": "38",
      "Kanji": "手"
  },
  {
      "Gakunen": "1",
      "Num": "39",
      "Kanji": "文"
  },
  {
      "Gakunen": "1",
      "Num": "40",
      "Kanji": "日"
  },
  {
      "Gakunen": "1",
      "Num": "41",
      "Kanji": "早"
  },
  {
      "Gakunen": "1",
      "Num": "42",
      "Kanji": "月"
  },
  {
      "Gakunen": "1",
      "Num": "43",
      "Kanji": "木"
  },
  {
      "Gakunen": "1",
      "Num": "44",
      "Kanji": "本"
  },
  {
      "Gakunen": "1",
      "Num": "45",
      "Kanji": "村"
  },
  {
      "Gakunen": "1",
      "Num": "46",
      "Kanji": "林"
  },
  {
      "Gakunen": "1",
      "Num": "47",
      "Kanji": "校"
  },
  {
      "Gakunen": "1",
      "Num": "48",
      "Kanji": "森"
  },
  {
      "Gakunen": "1",
      "Num": "49",
      "Kanji": "正"
  },
  {
      "Gakunen": "1",
      "Num": "50",
      "Kanji": "気"
  },
  {
      "Gakunen": "1",
      "Num": "51",
      "Kanji": "水"
  },
  {
      "Gakunen": "1",
      "Num": "52",
      "Kanji": "火"
  },
  {
      "Gakunen": "1",
      "Num": "53",
      "Kanji": "犬"
  },
  {
      "Gakunen": "1",
      "Num": "54",
      "Kanji": "玉"
  },
  {
      "Gakunen": "1",
      "Num": "55",
      "Kanji": "王"
  },
  {
      "Gakunen": "1",
      "Num": "56",
      "Kanji": "生"
  },
  {
      "Gakunen": "1",
      "Num": "57",
      "Kanji": "田"
  },
  {
      "Gakunen": "1",
      "Num": "58",
      "Kanji": "男"
  },
  {
      "Gakunen": "1",
      "Num": "59",
      "Kanji": "町"
  },
  {
      "Gakunen": "1",
      "Num": "60",
      "Kanji": "白"
  },
  {
      "Gakunen": "1",
      "Num": "61",
      "Kanji": "百"
  },
  {
      "Gakunen": "1",
      "Num": "62",
      "Kanji": "目"
  },
  {
      "Gakunen": "1",
      "Num": "63",
      "Kanji": "石"
  },
  {
      "Gakunen": "1",
      "Num": "64",
      "Kanji": "空"
  },
  {
      "Gakunen": "1",
      "Num": "65",
      "Kanji": "立"
  },
  {
      "Gakunen": "1",
      "Num": "66",
      "Kanji": "竹"
  },
  {
      "Gakunen": "1",
      "Num": "67",
      "Kanji": "糸"
  },
  {
      "Gakunen": "1",
      "Num": "68",
      "Kanji": "耳"
  },
  {
      "Gakunen": "1",
      "Num": "69",
      "Kanji": "花"
  },
  {
      "Gakunen": "1",
      "Num": "70",
      "Kanji": "草"
  },
  {
      "Gakunen": "1",
      "Num": "71",
      "Kanji": "虫"
  },
  {
      "Gakunen": "1",
      "Num": "72",
      "Kanji": "見"
  },
  {
      "Gakunen": "1",
      "Num": "73",
      "Kanji": "貝"
  },
  {
      "Gakunen": "1",
      "Num": "74",
      "Kanji": "赤"
  },
  {
      "Gakunen": "1",
      "Num": "75",
      "Kanji": "足"
  },
  {
      "Gakunen": "1",
      "Num": "76",
      "Kanji": "金"
  },
  {
      "Gakunen": "1",
      "Num": "77",
      "Kanji": "雨"
  },
  {
      "Gakunen": "1",
      "Num": "78",
      "Kanji": "青"
  },
  {
      "Gakunen": "1",
      "Num": "79",
      "Kanji": "音"
  },
  {
      "Gakunen": "1",
      "Num": "80",
      "Kanji": "車"
  }
]

export const NI_NEN_KANJI = 
[
  {
      "Gakunen": "2",
      "Num": "1",
      "Kanji": "万"
  },
  {
      "Gakunen": "2",
      "Num": "2",
      "Kanji": "丸"
  },
  {
      "Gakunen": "2",
      "Num": "3",
      "Kanji": "交"
  },
  {
      "Gakunen": "2",
      "Num": "4",
      "Kanji": "京"
  },
  {
      "Gakunen": "2",
      "Num": "5",
      "Kanji": "今"
  },
  {
      "Gakunen": "2",
      "Num": "6",
      "Kanji": "会"
  },
  {
      "Gakunen": "2",
      "Num": "7",
      "Kanji": "体"
  },
  {
      "Gakunen": "2",
      "Num": "8",
      "Kanji": "何"
  },
  {
      "Gakunen": "2",
      "Num": "9",
      "Kanji": "作"
  },
  {
      "Gakunen": "2",
      "Num": "10",
      "Kanji": "元"
  },
  {
      "Gakunen": "2",
      "Num": "11",
      "Kanji": "兄"
  },
  {
      "Gakunen": "2",
      "Num": "12",
      "Kanji": "光"
  },
  {
      "Gakunen": "2",
      "Num": "13",
      "Kanji": "公"
  },
  {
      "Gakunen": "2",
      "Num": "14",
      "Kanji": "内"
  },
  {
      "Gakunen": "2",
      "Num": "15",
      "Kanji": "冬"
  },
  {
      "Gakunen": "2",
      "Num": "16",
      "Kanji": "刀"
  },
  {
      "Gakunen": "2",
      "Num": "17",
      "Kanji": "分"
  },
  {
      "Gakunen": "2",
      "Num": "18",
      "Kanji": "切"
  },
  {
      "Gakunen": "2",
      "Num": "19",
      "Kanji": "前"
  },
  {
      "Gakunen": "2",
      "Num": "20",
      "Kanji": "北"
  },
  {
      "Gakunen": "2",
      "Num": "21",
      "Kanji": "午"
  },
  {
      "Gakunen": "2",
      "Num": "22",
      "Kanji": "半"
  },
  {
      "Gakunen": "2",
      "Num": "23",
      "Kanji": "南"
  },
  {
      "Gakunen": "2",
      "Num": "24",
      "Kanji": "原"
  },
  {
      "Gakunen": "2",
      "Num": "25",
      "Kanji": "友"
  },
  {
      "Gakunen": "2",
      "Num": "26",
      "Kanji": "古"
  },
  {
      "Gakunen": "2",
      "Num": "27",
      "Kanji": "台"
  },
  {
      "Gakunen": "2",
      "Num": "28",
      "Kanji": "合"
  },
  {
      "Gakunen": "2",
      "Num": "29",
      "Kanji": "同"
  },
  {
      "Gakunen": "2",
      "Num": "30",
      "Kanji": "回"
  },
  {
      "Gakunen": "2",
      "Num": "31",
      "Kanji": "図"
  },
  {
      "Gakunen": "2",
      "Num": "32",
      "Kanji": "国"
  },
  {
      "Gakunen": "2",
      "Num": "33",
      "Kanji": "園"
  },
  {
      "Gakunen": "2",
      "Num": "34",
      "Kanji": "地"
  },
  {
      "Gakunen": "2",
      "Num": "35",
      "Kanji": "場"
  },
  {
      "Gakunen": "2",
      "Num": "36",
      "Kanji": "声"
  },
  {
      "Gakunen": "2",
      "Num": "37",
      "Kanji": "売"
  },
  {
      "Gakunen": "2",
      "Num": "38",
      "Kanji": "夏"
  },
  {
      "Gakunen": "2",
      "Num": "39",
      "Kanji": "外"
  },
  {
      "Gakunen": "2",
      "Num": "40",
      "Kanji": "多"
  },
  {
      "Gakunen": "2",
      "Num": "41",
      "Kanji": "夜"
  },
  {
      "Gakunen": "2",
      "Num": "42",
      "Kanji": "太"
  },
  {
      "Gakunen": "2",
      "Num": "43",
      "Kanji": "妹"
  },
  {
      "Gakunen": "2",
      "Num": "44",
      "Kanji": "姉"
  },
  {
      "Gakunen": "2",
      "Num": "45",
      "Kanji": "室"
  },
  {
      "Gakunen": "2",
      "Num": "46",
      "Kanji": "家"
  },
  {
      "Gakunen": "2",
      "Num": "47",
      "Kanji": "寺"
  },
  {
      "Gakunen": "2",
      "Num": "48",
      "Kanji": "少"
  },
  {
      "Gakunen": "2",
      "Num": "49",
      "Kanji": "岩"
  },
  {
      "Gakunen": "2",
      "Num": "50",
      "Kanji": "工"
  },
  {
      "Gakunen": "2",
      "Num": "51",
      "Kanji": "市"
  },
  {
      "Gakunen": "2",
      "Num": "52",
      "Kanji": "帰"
  },
  {
      "Gakunen": "2",
      "Num": "53",
      "Kanji": "広"
  },
  {
      "Gakunen": "2",
      "Num": "54",
      "Kanji": "店"
  },
  {
      "Gakunen": "2",
      "Num": "55",
      "Kanji": "弓"
  },
  {
      "Gakunen": "2",
      "Num": "56",
      "Kanji": "引"
  },
  {
      "Gakunen": "2",
      "Num": "57",
      "Kanji": "弟"
  },
  {
      "Gakunen": "2",
      "Num": "58",
      "Kanji": "弱"
  },
  {
      "Gakunen": "2",
      "Num": "59",
      "Kanji": "強"
  },
  {
      "Gakunen": "2",
      "Num": "60",
      "Kanji": "当"
  },
  {
      "Gakunen": "2",
      "Num": "61",
      "Kanji": "形"
  },
  {
      "Gakunen": "2",
      "Num": "62",
      "Kanji": "後"
  },
  {
      "Gakunen": "2",
      "Num": "63",
      "Kanji": "心"
  },
  {
      "Gakunen": "2",
      "Num": "64",
      "Kanji": "思"
  },
  {
      "Gakunen": "2",
      "Num": "65",
      "Kanji": "戸"
  },
  {
      "Gakunen": "2",
      "Num": "66",
      "Kanji": "才"
  },
  {
      "Gakunen": "2",
      "Num": "67",
      "Kanji": "教"
  },
  {
      "Gakunen": "2",
      "Num": "68",
      "Kanji": "数"
  },
  {
      "Gakunen": "2",
      "Num": "69",
      "Kanji": "新"
  },
  {
      "Gakunen": "2",
      "Num": "70",
      "Kanji": "方"
  },
  {
      "Gakunen": "2",
      "Num": "71",
      "Kanji": "明"
  },
  {
      "Gakunen": "2",
      "Num": "72",
      "Kanji": "星"
  },
  {
      "Gakunen": "2",
      "Num": "73",
      "Kanji": "春"
  },
  {
      "Gakunen": "2",
      "Num": "74",
      "Kanji": "昼"
  },
  {
      "Gakunen": "2",
      "Num": "75",
      "Kanji": "時"
  },
  {
      "Gakunen": "2",
      "Num": "76",
      "Kanji": "晴"
  },
  {
      "Gakunen": "2",
      "Num": "77",
      "Kanji": "曜"
  },
  {
      "Gakunen": "2",
      "Num": "78",
      "Kanji": "書"
  },
  {
      "Gakunen": "2",
      "Num": "79",
      "Kanji": "朝"
  },
  {
      "Gakunen": "2",
      "Num": "80",
      "Kanji": "来"
  },
  {
      "Gakunen": "2",
      "Num": "81",
      "Kanji": "東"
  },
  {
      "Gakunen": "2",
      "Num": "82",
      "Kanji": "楽"
  },
  {
      "Gakunen": "2",
      "Num": "83",
      "Kanji": "歌"
  },
  {
      "Gakunen": "2",
      "Num": "84",
      "Kanji": "止"
  },
  {
      "Gakunen": "2",
      "Num": "85",
      "Kanji": "歩"
  },
  {
      "Gakunen": "2",
      "Num": "86",
      "Kanji": "母"
  },
  {
      "Gakunen": "2",
      "Num": "87",
      "Kanji": "毎"
  },
  {
      "Gakunen": "2",
      "Num": "88",
      "Kanji": "毛"
  },
  {
      "Gakunen": "2",
      "Num": "89",
      "Kanji": "池"
  },
  {
      "Gakunen": "2",
      "Num": "90",
      "Kanji": "汽"
  },
  {
      "Gakunen": "2",
      "Num": "91",
      "Kanji": "活"
  },
  {
      "Gakunen": "2",
      "Num": "92",
      "Kanji": "海"
  },
  {
      "Gakunen": "2",
      "Num": "93",
      "Kanji": "点"
  },
  {
      "Gakunen": "2",
      "Num": "94",
      "Kanji": "父"
  },
  {
      "Gakunen": "2",
      "Num": "95",
      "Kanji": "牛"
  },
  {
      "Gakunen": "2",
      "Num": "96",
      "Kanji": "用"
  },
  {
      "Gakunen": "2",
      "Num": "97",
      "Kanji": "画"
  },
  {
      "Gakunen": "2",
      "Num": "98",
      "Kanji": "番"
  },
  {
      "Gakunen": "2",
      "Num": "99",
      "Kanji": "直"
  },
  {
      "Gakunen": "2",
      "Num": "100",
      "Kanji": "矢"
  },
  {
      "Gakunen": "2",
      "Num": "101",
      "Kanji": "知"
  },
  {
      "Gakunen": "2",
      "Num": "102",
      "Kanji": "社"
  },
  {
      "Gakunen": "2",
      "Num": "103",
      "Kanji": "秋"
  },
  {
      "Gakunen": "2",
      "Num": "104",
      "Kanji": "科"
  },
  {
      "Gakunen": "2",
      "Num": "105",
      "Kanji": "答"
  },
  {
      "Gakunen": "2",
      "Num": "106",
      "Kanji": "算"
  },
  {
      "Gakunen": "2",
      "Num": "107",
      "Kanji": "米"
  },
  {
      "Gakunen": "2",
      "Num": "108",
      "Kanji": "紙"
  },
  {
      "Gakunen": "2",
      "Num": "109",
      "Kanji": "細"
  },
  {
      "Gakunen": "2",
      "Num": "110",
      "Kanji": "組"
  },
  {
      "Gakunen": "2",
      "Num": "111",
      "Kanji": "絵"
  },
  {
      "Gakunen": "2",
      "Num": "112",
      "Kanji": "線"
  },
  {
      "Gakunen": "2",
      "Num": "113",
      "Kanji": "羽"
  },
  {
      "Gakunen": "2",
      "Num": "114",
      "Kanji": "考"
  },
  {
      "Gakunen": "2",
      "Num": "115",
      "Kanji": "聞"
  },
  {
      "Gakunen": "2",
      "Num": "116",
      "Kanji": "肉"
  },
  {
      "Gakunen": "2",
      "Num": "117",
      "Kanji": "自"
  },
  {
      "Gakunen": "2",
      "Num": "118",
      "Kanji": "船"
  },
  {
      "Gakunen": "2",
      "Num": "119",
      "Kanji": "色"
  },
  {
      "Gakunen": "2",
      "Num": "120",
      "Kanji": "茶"
  },
  {
      "Gakunen": "2",
      "Num": "121",
      "Kanji": "行"
  },
  {
      "Gakunen": "2",
      "Num": "122",
      "Kanji": "西"
  },
  {
      "Gakunen": "2",
      "Num": "123",
      "Kanji": "親"
  },
  {
      "Gakunen": "2",
      "Num": "124",
      "Kanji": "角"
  },
  {
      "Gakunen": "2",
      "Num": "125",
      "Kanji": "言"
  },
  {
      "Gakunen": "2",
      "Num": "126",
      "Kanji": "計"
  },
  {
      "Gakunen": "2",
      "Num": "127",
      "Kanji": "記"
  },
  {
      "Gakunen": "2",
      "Num": "128",
      "Kanji": "話"
  },
  {
      "Gakunen": "2",
      "Num": "129",
      "Kanji": "語"
  },
  {
      "Gakunen": "2",
      "Num": "130",
      "Kanji": "読"
  },
  {
      "Gakunen": "2",
      "Num": "131",
      "Kanji": "谷"
  },
  {
      "Gakunen": "2",
      "Num": "132",
      "Kanji": "買"
  },
  {
      "Gakunen": "2",
      "Num": "133",
      "Kanji": "走"
  },
  {
      "Gakunen": "2",
      "Num": "134",
      "Kanji": "近"
  },
  {
      "Gakunen": "2",
      "Num": "135",
      "Kanji": "通"
  },
  {
      "Gakunen": "2",
      "Num": "136",
      "Kanji": "週"
  },
  {
      "Gakunen": "2",
      "Num": "137",
      "Kanji": "道"
  },
  {
      "Gakunen": "2",
      "Num": "138",
      "Kanji": "遠"
  },
  {
      "Gakunen": "2",
      "Num": "139",
      "Kanji": "里"
  },
  {
      "Gakunen": "2",
      "Num": "140",
      "Kanji": "野"
  },
  {
      "Gakunen": "2",
      "Num": "141",
      "Kanji": "長"
  },
  {
      "Gakunen": "2",
      "Num": "142",
      "Kanji": "門"
  },
  {
      "Gakunen": "2",
      "Num": "143",
      "Kanji": "間"
  },
  {
      "Gakunen": "2",
      "Num": "144",
      "Kanji": "雪"
  },
  {
      "Gakunen": "2",
      "Num": "145",
      "Kanji": "雲"
  },
  {
      "Gakunen": "2",
      "Num": "146",
      "Kanji": "電"
  },
  {
      "Gakunen": "2",
      "Num": "147",
      "Kanji": "頭"
  },
  {
      "Gakunen": "2",
      "Num": "148",
      "Kanji": "顔"
  },
  {
      "Gakunen": "2",
      "Num": "149",
      "Kanji": "風"
  },
  {
      "Gakunen": "2",
      "Num": "150",
      "Kanji": "食"
  },
  {
      "Gakunen": "2",
      "Num": "151",
      "Kanji": "首"
  },
  {
      "Gakunen": "2",
      "Num": "152",
      "Kanji": "馬"
  },
  {
      "Gakunen": "2",
      "Num": "153",
      "Kanji": "高"
  },
  {
      "Gakunen": "2",
      "Num": "154",
      "Kanji": "魚"
  },
  {
      "Gakunen": "2",
      "Num": "155",
      "Kanji": "鳥"
  },
  {
      "Gakunen": "2",
      "Num": "156",
      "Kanji": "鳴"
  },
  {
      "Gakunen": "2",
      "Num": "157",
      "Kanji": "麦"
  },
  {
      "Gakunen": "2",
      "Num": "158",
      "Kanji": "黄"
  },
  {
      "Gakunen": "2",
      "Num": "159",
      "Kanji": "黒"
  },
  {
      "Gakunen": "2",
      "Num": "160",
      "Kanji": "理"
  }
]

export const SAN_NEN_KANJI = 
[
    {
        "Gakunen": "3",
        "Num": "1",
        "Kanji": "丁"
    },
    {
        "Gakunen": "3",
        "Num": "2",
        "Kanji": "世"
    },
    {
        "Gakunen": "3",
        "Num": "3",
        "Kanji": "両"
    },
    {
        "Gakunen": "3",
        "Num": "4",
        "Kanji": "主"
    },
    {
        "Gakunen": "3",
        "Num": "5",
        "Kanji": "乗"
    },
    {
        "Gakunen": "3",
        "Num": "6",
        "Kanji": "予"
    },
    {
        "Gakunen": "3",
        "Num": "7",
        "Kanji": "事"
    },
    {
        "Gakunen": "3",
        "Num": "8",
        "Kanji": "仕"
    },
    {
        "Gakunen": "3",
        "Num": "9",
        "Kanji": "他"
    },
    {
        "Gakunen": "3",
        "Num": "10",
        "Kanji": "代"
    },
    {
        "Gakunen": "3",
        "Num": "11",
        "Kanji": "住"
    },
    {
        "Gakunen": "3",
        "Num": "12",
        "Kanji": "使"
    },
    {
        "Gakunen": "3",
        "Num": "13",
        "Kanji": "係"
    },
    {
        "Gakunen": "3",
        "Num": "14",
        "Kanji": "倍"
    },
    {
        "Gakunen": "3",
        "Num": "15",
        "Kanji": "全"
    },
    {
        "Gakunen": "3",
        "Num": "16",
        "Kanji": "具"
    },
    {
        "Gakunen": "3",
        "Num": "17",
        "Kanji": "写"
    },
    {
        "Gakunen": "3",
        "Num": "18",
        "Kanji": "列"
    },
    {
        "Gakunen": "3",
        "Num": "19",
        "Kanji": "助"
    },
    {
        "Gakunen": "3",
        "Num": "20",
        "Kanji": "勉"
    },
    {
        "Gakunen": "3",
        "Num": "21",
        "Kanji": "動"
    },
    {
        "Gakunen": "3",
        "Num": "22",
        "Kanji": "勝"
    },
    {
        "Gakunen": "3",
        "Num": "23",
        "Kanji": "化"
    },
    {
        "Gakunen": "3",
        "Num": "24",
        "Kanji": "区"
    },
    {
        "Gakunen": "3",
        "Num": "25",
        "Kanji": "医"
    },
    {
        "Gakunen": "3",
        "Num": "26",
        "Kanji": "去"
    },
    {
        "Gakunen": "3",
        "Num": "27",
        "Kanji": "反"
    },
    {
        "Gakunen": "3",
        "Num": "28",
        "Kanji": "取"
    },
    {
        "Gakunen": "3",
        "Num": "29",
        "Kanji": "受"
    },
    {
        "Gakunen": "3",
        "Num": "30",
        "Kanji": "号"
    },
    {
        "Gakunen": "3",
        "Num": "31",
        "Kanji": "向"
    },
    {
        "Gakunen": "3",
        "Num": "32",
        "Kanji": "君"
    },
    {
        "Gakunen": "3",
        "Num": "33",
        "Kanji": "味"
    },
    {
        "Gakunen": "3",
        "Num": "34",
        "Kanji": "命"
    },
    {
        "Gakunen": "3",
        "Num": "35",
        "Kanji": "品"
    },
    {
        "Gakunen": "3",
        "Num": "36",
        "Kanji": "員"
    },
    {
        "Gakunen": "3",
        "Num": "37",
        "Kanji": "商"
    },
    {
        "Gakunen": "3",
        "Num": "38",
        "Kanji": "問"
    },
    {
        "Gakunen": "3",
        "Num": "39",
        "Kanji": "坂"
    },
    {
        "Gakunen": "3",
        "Num": "40",
        "Kanji": "央"
    },
    {
        "Gakunen": "3",
        "Num": "41",
        "Kanji": "始"
    },
    {
        "Gakunen": "3",
        "Num": "42",
        "Kanji": "委"
    },
    {
        "Gakunen": "3",
        "Num": "43",
        "Kanji": "守"
    },
    {
        "Gakunen": "3",
        "Num": "44",
        "Kanji": "安"
    },
    {
        "Gakunen": "3",
        "Num": "45",
        "Kanji": "定"
    },
    {
        "Gakunen": "3",
        "Num": "46",
        "Kanji": "実"
    },
    {
        "Gakunen": "3",
        "Num": "47",
        "Kanji": "客"
    },
    {
        "Gakunen": "3",
        "Num": "48",
        "Kanji": "宮"
    },
    {
        "Gakunen": "3",
        "Num": "49",
        "Kanji": "宿"
    },
    {
        "Gakunen": "3",
        "Num": "50",
        "Kanji": "寒"
    },
    {
        "Gakunen": "3",
        "Num": "51",
        "Kanji": "対"
    },
    {
        "Gakunen": "3",
        "Num": "52",
        "Kanji": "局"
    },
    {
        "Gakunen": "3",
        "Num": "53",
        "Kanji": "屋"
    },
    {
        "Gakunen": "3",
        "Num": "54",
        "Kanji": "岸"
    },
    {
        "Gakunen": "3",
        "Num": "55",
        "Kanji": "島"
    },
    {
        "Gakunen": "3",
        "Num": "56",
        "Kanji": "州"
    },
    {
        "Gakunen": "3",
        "Num": "57",
        "Kanji": "帳"
    },
    {
        "Gakunen": "3",
        "Num": "58",
        "Kanji": "平"
    },
    {
        "Gakunen": "3",
        "Num": "59",
        "Kanji": "幸"
    },
    {
        "Gakunen": "3",
        "Num": "60",
        "Kanji": "度"
    },
    {
        "Gakunen": "3",
        "Num": "61",
        "Kanji": "庫"
    },
    {
        "Gakunen": "3",
        "Num": "62",
        "Kanji": "庭"
    },
    {
        "Gakunen": "3",
        "Num": "63",
        "Kanji": "式"
    },
    {
        "Gakunen": "3",
        "Num": "64",
        "Kanji": "役"
    },
    {
        "Gakunen": "3",
        "Num": "65",
        "Kanji": "待"
    },
    {
        "Gakunen": "3",
        "Num": "66",
        "Kanji": "急"
    },
    {
        "Gakunen": "3",
        "Num": "67",
        "Kanji": "息"
    },
    {
        "Gakunen": "3",
        "Num": "68",
        "Kanji": "悪"
    },
    {
        "Gakunen": "3",
        "Num": "69",
        "Kanji": "悲"
    },
    {
        "Gakunen": "3",
        "Num": "70",
        "Kanji": "想"
    },
    {
        "Gakunen": "3",
        "Num": "71",
        "Kanji": "意"
    },
    {
        "Gakunen": "3",
        "Num": "72",
        "Kanji": "感"
    },
    {
        "Gakunen": "3",
        "Num": "73",
        "Kanji": "所"
    },
    {
        "Gakunen": "3",
        "Num": "74",
        "Kanji": "打"
    },
    {
        "Gakunen": "3",
        "Num": "75",
        "Kanji": "投"
    },
    {
        "Gakunen": "3",
        "Num": "76",
        "Kanji": "拾"
    },
    {
        "Gakunen": "3",
        "Num": "77",
        "Kanji": "持"
    },
    {
        "Gakunen": "3",
        "Num": "78",
        "Kanji": "指"
    },
    {
        "Gakunen": "3",
        "Num": "79",
        "Kanji": "放"
    },
    {
        "Gakunen": "3",
        "Num": "80",
        "Kanji": "整"
    },
    {
        "Gakunen": "3",
        "Num": "81",
        "Kanji": "旅"
    },
    {
        "Gakunen": "3",
        "Num": "82",
        "Kanji": "族"
    },
    {
        "Gakunen": "3",
        "Num": "83",
        "Kanji": "昔"
    },
    {
        "Gakunen": "3",
        "Num": "84",
        "Kanji": "昭"
    },
    {
        "Gakunen": "3",
        "Num": "85",
        "Kanji": "暑"
    },
    {
        "Gakunen": "3",
        "Num": "86",
        "Kanji": "暗"
    },
    {
        "Gakunen": "3",
        "Num": "87",
        "Kanji": "曲"
    },
    {
        "Gakunen": "3",
        "Num": "88",
        "Kanji": "有"
    },
    {
        "Gakunen": "3",
        "Num": "89",
        "Kanji": "服"
    },
    {
        "Gakunen": "3",
        "Num": "90",
        "Kanji": "期"
    },
    {
        "Gakunen": "3",
        "Num": "91",
        "Kanji": "板"
    },
    {
        "Gakunen": "3",
        "Num": "92",
        "Kanji": "柱"
    },
    {
        "Gakunen": "3",
        "Num": "93",
        "Kanji": "根"
    },
    {
        "Gakunen": "3",
        "Num": "94",
        "Kanji": "植"
    },
    {
        "Gakunen": "3",
        "Num": "95",
        "Kanji": "業"
    },
    {
        "Gakunen": "3",
        "Num": "96",
        "Kanji": "様"
    },
    {
        "Gakunen": "3",
        "Num": "97",
        "Kanji": "横"
    },
    {
        "Gakunen": "3",
        "Num": "98",
        "Kanji": "橋"
    },
    {
        "Gakunen": "3",
        "Num": "99",
        "Kanji": "次"
    },
    {
        "Gakunen": "3",
        "Num": "100",
        "Kanji": "歯"
    },
    {
        "Gakunen": "3",
        "Num": "101",
        "Kanji": "死"
    },
    {
        "Gakunen": "3",
        "Num": "102",
        "Kanji": "氷"
    },
    {
        "Gakunen": "3",
        "Num": "103",
        "Kanji": "決"
    },
    {
        "Gakunen": "3",
        "Num": "104",
        "Kanji": "油"
    },
    {
        "Gakunen": "3",
        "Num": "105",
        "Kanji": "波"
    },
    {
        "Gakunen": "3",
        "Num": "106",
        "Kanji": "注"
    },
    {
        "Gakunen": "3",
        "Num": "107",
        "Kanji": "泳"
    },
    {
        "Gakunen": "3",
        "Num": "108",
        "Kanji": "洋"
    },
    {
        "Gakunen": "3",
        "Num": "109",
        "Kanji": "流"
    },
    {
        "Gakunen": "3",
        "Num": "110",
        "Kanji": "消"
    },
    {
        "Gakunen": "3",
        "Num": "111",
        "Kanji": "深"
    },
    {
        "Gakunen": "3",
        "Num": "112",
        "Kanji": "温"
    },
    {
        "Gakunen": "3",
        "Num": "113",
        "Kanji": "港"
    },
    {
        "Gakunen": "3",
        "Num": "114",
        "Kanji": "湖"
    },
    {
        "Gakunen": "3",
        "Num": "115",
        "Kanji": "湯"
    },
    {
        "Gakunen": "3",
        "Num": "116",
        "Kanji": "漢"
    },
    {
        "Gakunen": "3",
        "Num": "117",
        "Kanji": "炭"
    },
    {
        "Gakunen": "3",
        "Num": "118",
        "Kanji": "物"
    },
    {
        "Gakunen": "3",
        "Num": "119",
        "Kanji": "球"
    },
    {
        "Gakunen": "3",
        "Num": "120",
        "Kanji": "由"
    },
    {
        "Gakunen": "3",
        "Num": "121",
        "Kanji": "申"
    },
    {
        "Gakunen": "3",
        "Num": "122",
        "Kanji": "界"
    },
    {
        "Gakunen": "3",
        "Num": "123",
        "Kanji": "畑"
    },
    {
        "Gakunen": "3",
        "Num": "124",
        "Kanji": "病"
    },
    {
        "Gakunen": "3",
        "Num": "125",
        "Kanji": "発"
    },
    {
        "Gakunen": "3",
        "Num": "126",
        "Kanji": "登"
    },
    {
        "Gakunen": "3",
        "Num": "127",
        "Kanji": "皮"
    },
    {
        "Gakunen": "3",
        "Num": "128",
        "Kanji": "皿"
    },
    {
        "Gakunen": "3",
        "Num": "129",
        "Kanji": "相"
    },
    {
        "Gakunen": "3",
        "Num": "130",
        "Kanji": "県"
    },
    {
        "Gakunen": "3",
        "Num": "131",
        "Kanji": "真"
    },
    {
        "Gakunen": "3",
        "Num": "132",
        "Kanji": "着"
    },
    {
        "Gakunen": "3",
        "Num": "133",
        "Kanji": "短"
    },
    {
        "Gakunen": "3",
        "Num": "134",
        "Kanji": "研"
    },
    {
        "Gakunen": "3",
        "Num": "135",
        "Kanji": "礼"
    },
    {
        "Gakunen": "3",
        "Num": "136",
        "Kanji": "神"
    },
    {
        "Gakunen": "3",
        "Num": "137",
        "Kanji": "祭"
    },
    {
        "Gakunen": "3",
        "Num": "138",
        "Kanji": "福"
    },
    {
        "Gakunen": "3",
        "Num": "139",
        "Kanji": "秒"
    },
    {
        "Gakunen": "3",
        "Num": "140",
        "Kanji": "究"
    },
    {
        "Gakunen": "3",
        "Num": "141",
        "Kanji": "章"
    },
    {
        "Gakunen": "3",
        "Num": "142",
        "Kanji": "童"
    },
    {
        "Gakunen": "3",
        "Num": "143",
        "Kanji": "笛"
    },
    {
        "Gakunen": "3",
        "Num": "144",
        "Kanji": "第"
    },
    {
        "Gakunen": "3",
        "Num": "145",
        "Kanji": "筆"
    },
    {
        "Gakunen": "3",
        "Num": "146",
        "Kanji": "等"
    },
    {
        "Gakunen": "3",
        "Num": "147",
        "Kanji": "箱"
    },
    {
        "Gakunen": "3",
        "Num": "148",
        "Kanji": "級"
    },
    {
        "Gakunen": "3",
        "Num": "149",
        "Kanji": "終"
    },
    {
        "Gakunen": "3",
        "Num": "150",
        "Kanji": "緑"
    },
    {
        "Gakunen": "3",
        "Num": "151",
        "Kanji": "練"
    },
    {
        "Gakunen": "3",
        "Num": "152",
        "Kanji": "羊"
    },
    {
        "Gakunen": "3",
        "Num": "153",
        "Kanji": "美"
    },
    {
        "Gakunen": "3",
        "Num": "154",
        "Kanji": "習"
    },
    {
        "Gakunen": "3",
        "Num": "155",
        "Kanji": "者"
    },
    {
        "Gakunen": "3",
        "Num": "156",
        "Kanji": "育"
    },
    {
        "Gakunen": "3",
        "Num": "157",
        "Kanji": "苦"
    },
    {
        "Gakunen": "3",
        "Num": "158",
        "Kanji": "荷"
    },
    {
        "Gakunen": "3",
        "Num": "159",
        "Kanji": "落"
    },
    {
        "Gakunen": "3",
        "Num": "160",
        "Kanji": "葉"
    },
    {
        "Gakunen": "3",
        "Num": "161",
        "Kanji": "薬"
    },
    {
        "Gakunen": "3",
        "Num": "162",
        "Kanji": "血"
    },
    {
        "Gakunen": "3",
        "Num": "163",
        "Kanji": "表"
    },
    {
        "Gakunen": "3",
        "Num": "164",
        "Kanji": "詩"
    },
    {
        "Gakunen": "3",
        "Num": "165",
        "Kanji": "調"
    },
    {
        "Gakunen": "3",
        "Num": "166",
        "Kanji": "談"
    },
    {
        "Gakunen": "3",
        "Num": "167",
        "Kanji": "豆"
    },
    {
        "Gakunen": "3",
        "Num": "168",
        "Kanji": "負"
    },
    {
        "Gakunen": "3",
        "Num": "169",
        "Kanji": "起"
    },
    {
        "Gakunen": "3",
        "Num": "170",
        "Kanji": "路"
    },
    {
        "Gakunen": "3",
        "Num": "171",
        "Kanji": "身"
    },
    {
        "Gakunen": "3",
        "Num": "172",
        "Kanji": "転"
    },
    {
        "Gakunen": "3",
        "Num": "173",
        "Kanji": "軽"
    },
    {
        "Gakunen": "3",
        "Num": "174",
        "Kanji": "農"
    },
    {
        "Gakunen": "3",
        "Num": "175",
        "Kanji": "返"
    },
    {
        "Gakunen": "3",
        "Num": "176",
        "Kanji": "追"
    },
    {
        "Gakunen": "3",
        "Num": "177",
        "Kanji": "送"
    },
    {
        "Gakunen": "3",
        "Num": "178",
        "Kanji": "速"
    },
    {
        "Gakunen": "3",
        "Num": "179",
        "Kanji": "進"
    },
    {
        "Gakunen": "3",
        "Num": "180",
        "Kanji": "遊"
    },
    {
        "Gakunen": "3",
        "Num": "181",
        "Kanji": "運"
    },
    {
        "Gakunen": "3",
        "Num": "182",
        "Kanji": "部"
    },
    {
        "Gakunen": "3",
        "Num": "183",
        "Kanji": "都"
    },
    {
        "Gakunen": "3",
        "Num": "184",
        "Kanji": "配"
    },
    {
        "Gakunen": "3",
        "Num": "185",
        "Kanji": "酒"
    },
    {
        "Gakunen": "3",
        "Num": "186",
        "Kanji": "重"
    },
    {
        "Gakunen": "3",
        "Num": "187",
        "Kanji": "鉄"
    },
    {
        "Gakunen": "3",
        "Num": "188",
        "Kanji": "銀"
    },
    {
        "Gakunen": "3",
        "Num": "189",
        "Kanji": "開"
    },
    {
        "Gakunen": "3",
        "Num": "190",
        "Kanji": "院"
    },
    {
        "Gakunen": "3",
        "Num": "191",
        "Kanji": "陽"
    },
    {
        "Gakunen": "3",
        "Num": "192",
        "Kanji": "階"
    },
    {
        "Gakunen": "3",
        "Num": "193",
        "Kanji": "集"
    },
    {
        "Gakunen": "3",
        "Num": "194",
        "Kanji": "面"
    },
    {
        "Gakunen": "3",
        "Num": "195",
        "Kanji": "題"
    },
    {
        "Gakunen": "3",
        "Num": "196",
        "Kanji": "飲"
    },
    {
        "Gakunen": "3",
        "Num": "197",
        "Kanji": "館"
    },
    {
        "Gakunen": "3",
        "Num": "198",
        "Kanji": "駅"
    },
    {
        "Gakunen": "3",
        "Num": "199",
        "Kanji": "鼻"
    },
    {
        "Gakunen": "3",
        "Num": "200",
        "Kanji": "和"
    }
]

export const YON_NEN_KANJI = 
[
  {
      "Gakunen": "4",
      "Num": "1",
      "Kanji": "愛"
  },
  {
      "Gakunen": "4",
      "Num": "2",
      "Kanji": "案"
  },
  {
      "Gakunen": "4",
      "Num": "3",
      "Kanji": "以"
  },
  {
      "Gakunen": "4",
      "Num": "4",
      "Kanji": "衣"
  },
  {
      "Gakunen": "4",
      "Num": "5",
      "Kanji": "位"
  },
  {
      "Gakunen": "4",
      "Num": "6",
      "Kanji": "茨"
  },
  {
      "Gakunen": "4",
      "Num": "7",
      "Kanji": "印"
  },
  {
      "Gakunen": "4",
      "Num": "8",
      "Kanji": "英"
  },
  {
      "Gakunen": "4",
      "Num": "9",
      "Kanji": "栄"
  },
  {
      "Gakunen": "4",
      "Num": "10",
      "Kanji": "媛"
  },
  {
      "Gakunen": "4",
      "Num": "11",
      "Kanji": "塩"
  },
  {
      "Gakunen": "4",
      "Num": "12",
      "Kanji": "岡"
  },
  {
      "Gakunen": "4",
      "Num": "13",
      "Kanji": "億"
  },
  {
      "Gakunen": "4",
      "Num": "14",
      "Kanji": "加"
  },
  {
      "Gakunen": "4",
      "Num": "15",
      "Kanji": "果"
  },
  {
      "Gakunen": "4",
      "Num": "16",
      "Kanji": "貨"
  },
  {
      "Gakunen": "4",
      "Num": "17",
      "Kanji": "課"
  },
  {
      "Gakunen": "4",
      "Num": "18",
      "Kanji": "芽"
  },
  {
      "Gakunen": "4",
      "Num": "19",
      "Kanji": "賀"
  },
  {
      "Gakunen": "4",
      "Num": "20",
      "Kanji": "改"
  },
  {
      "Gakunen": "4",
      "Num": "21",
      "Kanji": "械"
  },
  {
      "Gakunen": "4",
      "Num": "22",
      "Kanji": "害"
  },
  {
      "Gakunen": "4",
      "Num": "23",
      "Kanji": "街"
  },
  {
      "Gakunen": "4",
      "Num": "24",
      "Kanji": "各"
  },
  {
      "Gakunen": "4",
      "Num": "25",
      "Kanji": "覚"
  },
  {
      "Gakunen": "4",
      "Num": "26",
      "Kanji": "潟"
  },
  {
      "Gakunen": "4",
      "Num": "27",
      "Kanji": "完"
  },
  {
      "Gakunen": "4",
      "Num": "28",
      "Kanji": "官"
  },
  {
      "Gakunen": "4",
      "Num": "29",
      "Kanji": "管"
  },
  {
      "Gakunen": "4",
      "Num": "30",
      "Kanji": "関"
  },
  {
      "Gakunen": "4",
      "Num": "31",
      "Kanji": "観"
  },
  {
      "Gakunen": "4",
      "Num": "32",
      "Kanji": "願"
  },
  {
      "Gakunen": "4",
      "Num": "33",
      "Kanji": "岐"
  },
  {
      "Gakunen": "4",
      "Num": "34",
      "Kanji": "希"
  },
  {
      "Gakunen": "4",
      "Num": "35",
      "Kanji": "季"
  },
  {
      "Gakunen": "4",
      "Num": "36",
      "Kanji": "旗"
  },
  {
      "Gakunen": "4",
      "Num": "37",
      "Kanji": "器"
  },
  {
      "Gakunen": "4",
      "Num": "38",
      "Kanji": "機"
  },
  {
      "Gakunen": "4",
      "Num": "39",
      "Kanji": "議"
  },
  {
      "Gakunen": "4",
      "Num": "40",
      "Kanji": "求"
  },
  {
      "Gakunen": "4",
      "Num": "41",
      "Kanji": "泣"
  },
  {
      "Gakunen": "4",
      "Num": "42",
      "Kanji": "給"
  },
  {
      "Gakunen": "4",
      "Num": "43",
      "Kanji": "挙"
  },
  {
      "Gakunen": "4",
      "Num": "44",
      "Kanji": "漁"
  },
  {
      "Gakunen": "4",
      "Num": "45",
      "Kanji": "共"
  },
  {
      "Gakunen": "4",
      "Num": "46",
      "Kanji": "協"
  },
  {
      "Gakunen": "4",
      "Num": "47",
      "Kanji": "鏡"
  },
  {
      "Gakunen": "4",
      "Num": "48",
      "Kanji": "競"
  },
  {
      "Gakunen": "4",
      "Num": "49",
      "Kanji": "極"
  },
  {
      "Gakunen": "4",
      "Num": "50",
      "Kanji": "熊"
  },
  {
      "Gakunen": "4",
      "Num": "51",
      "Kanji": "訓"
  },
  {
      "Gakunen": "4",
      "Num": "52",
      "Kanji": "軍"
  },
  {
      "Gakunen": "4",
      "Num": "53",
      "Kanji": "郡"
  },
  {
      "Gakunen": "4",
      "Num": "54",
      "Kanji": "群"
  },
  {
      "Gakunen": "4",
      "Num": "55",
      "Kanji": "径"
  },
  {
      "Gakunen": "4",
      "Num": "56",
      "Kanji": "景"
  },
  {
      "Gakunen": "4",
      "Num": "57",
      "Kanji": "芸"
  },
  {
      "Gakunen": "4",
      "Num": "58",
      "Kanji": "欠"
  },
  {
      "Gakunen": "4",
      "Num": "59",
      "Kanji": "結"
  },
  {
      "Gakunen": "4",
      "Num": "60",
      "Kanji": "建"
  },
  {
      "Gakunen": "4",
      "Num": "61",
      "Kanji": "健"
  },
  {
      "Gakunen": "4",
      "Num": "62",
      "Kanji": "験"
  },
  {
      "Gakunen": "4",
      "Num": "63",
      "Kanji": "固"
  },
  {
      "Gakunen": "4",
      "Num": "64",
      "Kanji": "功"
  },
  {
      "Gakunen": "4",
      "Num": "65",
      "Kanji": "好"
  },
  {
      "Gakunen": "4",
      "Num": "66",
      "Kanji": "香"
  },
  {
      "Gakunen": "4",
      "Num": "67",
      "Kanji": "候"
  },
  {
      "Gakunen": "4",
      "Num": "68",
      "Kanji": "康"
  },
  {
      "Gakunen": "4",
      "Num": "69",
      "Kanji": "佐"
  },
  {
      "Gakunen": "4",
      "Num": "70",
      "Kanji": "差"
  },
  {
      "Gakunen": "4",
      "Num": "71",
      "Kanji": "菜"
  },
  {
      "Gakunen": "4",
      "Num": "72",
      "Kanji": "最"
  },
  {
      "Gakunen": "4",
      "Num": "73",
      "Kanji": "埼"
  },
  {
      "Gakunen": "4",
      "Num": "74",
      "Kanji": "材"
  },
  {
      "Gakunen": "4",
      "Num": "75",
      "Kanji": "崎"
  },
  {
      "Gakunen": "4",
      "Num": "76",
      "Kanji": "昨"
  },
  {
      "Gakunen": "4",
      "Num": "77",
      "Kanji": "札"
  },
  {
      "Gakunen": "4",
      "Num": "78",
      "Kanji": "刷"
  },
  {
      "Gakunen": "4",
      "Num": "79",
      "Kanji": "察"
  },
  {
      "Gakunen": "4",
      "Num": "80",
      "Kanji": "参"
  },
  {
      "Gakunen": "4",
      "Num": "81",
      "Kanji": "産"
  },
  {
      "Gakunen": "4",
      "Num": "82",
      "Kanji": "散"
  },
  {
      "Gakunen": "4",
      "Num": "83",
      "Kanji": "残"
  },
  {
      "Gakunen": "4",
      "Num": "84",
      "Kanji": "氏"
  },
  {
      "Gakunen": "4",
      "Num": "85",
      "Kanji": "司"
  },
  {
      "Gakunen": "4",
      "Num": "86",
      "Kanji": "試"
  },
  {
      "Gakunen": "4",
      "Num": "87",
      "Kanji": "児"
  },
  {
      "Gakunen": "4",
      "Num": "88",
      "Kanji": "治"
  },
  {
      "Gakunen": "4",
      "Num": "89",
      "Kanji": "滋"
  },
  {
      "Gakunen": "4",
      "Num": "90",
      "Kanji": "辞"
  },
  {
      "Gakunen": "4",
      "Num": "91",
      "Kanji": "鹿"
  },
  {
      "Gakunen": "4",
      "Num": "92",
      "Kanji": "失"
  },
  {
      "Gakunen": "4",
      "Num": "93",
      "Kanji": "借"
  },
  {
      "Gakunen": "4",
      "Num": "94",
      "Kanji": "種"
  },
  {
      "Gakunen": "4",
      "Num": "95",
      "Kanji": "周"
  },
  {
      "Gakunen": "4",
      "Num": "96",
      "Kanji": "祝"
  },
  {
      "Gakunen": "4",
      "Num": "97",
      "Kanji": "順"
  },
  {
      "Gakunen": "4",
      "Num": "98",
      "Kanji": "初"
  },
  {
      "Gakunen": "4",
      "Num": "99",
      "Kanji": "松"
  },
  {
      "Gakunen": "4",
      "Num": "100",
      "Kanji": "笑"
  },
  {
      "Gakunen": "4",
      "Num": "101",
      "Kanji": "唱"
  },
  {
      "Gakunen": "4",
      "Num": "102",
      "Kanji": "焼"
  },
  {
      "Gakunen": "4",
      "Num": "103",
      "Kanji": "照"
  },
  {
      "Gakunen": "4",
      "Num": "104",
      "Kanji": "城"
  },
  {
      "Gakunen": "4",
      "Num": "105",
      "Kanji": "縄"
  },
  {
      "Gakunen": "4",
      "Num": "106",
      "Kanji": "臣"
  },
  {
      "Gakunen": "4",
      "Num": "107",
      "Kanji": "信"
  },
  {
      "Gakunen": "4",
      "Num": "108",
      "Kanji": "井"
  },
  {
      "Gakunen": "4",
      "Num": "109",
      "Kanji": "成"
  },
  {
      "Gakunen": "4",
      "Num": "110",
      "Kanji": "省"
  },
  {
      "Gakunen": "4",
      "Num": "111",
      "Kanji": "清"
  },
  {
      "Gakunen": "4",
      "Num": "112",
      "Kanji": "静"
  },
  {
      "Gakunen": "4",
      "Num": "113",
      "Kanji": "席"
  },
  {
      "Gakunen": "4",
      "Num": "114",
      "Kanji": "積"
  },
  {
      "Gakunen": "4",
      "Num": "115",
      "Kanji": "折"
  },
  {
      "Gakunen": "4",
      "Num": "116",
      "Kanji": "節"
  },
  {
      "Gakunen": "4",
      "Num": "117",
      "Kanji": "説"
  },
  {
      "Gakunen": "4",
      "Num": "118",
      "Kanji": "浅"
  },
  {
      "Gakunen": "4",
      "Num": "119",
      "Kanji": "戦"
  },
  {
      "Gakunen": "4",
      "Num": "120",
      "Kanji": "選"
  },
  {
      "Gakunen": "4",
      "Num": "121",
      "Kanji": "然"
  },
  {
      "Gakunen": "4",
      "Num": "122",
      "Kanji": "争"
  },
  {
      "Gakunen": "4",
      "Num": "123",
      "Kanji": "倉"
  },
  {
      "Gakunen": "4",
      "Num": "124",
      "Kanji": "巣"
  },
  {
      "Gakunen": "4",
      "Num": "125",
      "Kanji": "束"
  },
  {
      "Gakunen": "4",
      "Num": "126",
      "Kanji": "側"
  },
  {
      "Gakunen": "4",
      "Num": "127",
      "Kanji": "続"
  },
  {
      "Gakunen": "4",
      "Num": "128",
      "Kanji": "卒"
  },
  {
      "Gakunen": "4",
      "Num": "129",
      "Kanji": "孫"
  },
  {
      "Gakunen": "4",
      "Num": "130",
      "Kanji": "帯"
  },
  {
      "Gakunen": "4",
      "Num": "131",
      "Kanji": "隊"
  },
  {
      "Gakunen": "4",
      "Num": "132",
      "Kanji": "達"
  },
  {
      "Gakunen": "4",
      "Num": "133",
      "Kanji": "単"
  },
  {
      "Gakunen": "4",
      "Num": "134",
      "Kanji": "置"
  },
  {
      "Gakunen": "4",
      "Num": "135",
      "Kanji": "仲"
  },
  {
      "Gakunen": "4",
      "Num": "136",
      "Kanji": "沖"
  },
  {
      "Gakunen": "4",
      "Num": "137",
      "Kanji": "兆"
  },
  {
      "Gakunen": "4",
      "Num": "138",
      "Kanji": "低"
  },
  {
      "Gakunen": "4",
      "Num": "139",
      "Kanji": "底"
  },
  {
      "Gakunen": "4",
      "Num": "140",
      "Kanji": "的"
  },
  {
      "Gakunen": "4",
      "Num": "141",
      "Kanji": "典"
  },
  {
      "Gakunen": "4",
      "Num": "142",
      "Kanji": "伝"
  },
  {
      "Gakunen": "4",
      "Num": "143",
      "Kanji": "徒"
  },
  {
      "Gakunen": "4",
      "Num": "144",
      "Kanji": "努"
  },
  {
      "Gakunen": "4",
      "Num": "145",
      "Kanji": "灯"
  },
  {
      "Gakunen": "4",
      "Num": "146",
      "Kanji": "働"
  },
  {
      "Gakunen": "4",
      "Num": "147",
      "Kanji": "特"
  },
  {
      "Gakunen": "4",
      "Num": "148",
      "Kanji": "徳"
  },
  {
      "Gakunen": "4",
      "Num": "149",
      "Kanji": "栃"
  },
  {
      "Gakunen": "4",
      "Num": "150",
      "Kanji": "奈"
  },
  {
      "Gakunen": "4",
      "Num": "151",
      "Kanji": "梨"
  },
  {
      "Gakunen": "4",
      "Num": "152",
      "Kanji": "熱"
  },
  {
      "Gakunen": "4",
      "Num": "153",
      "Kanji": "念"
  },
  {
      "Gakunen": "4",
      "Num": "154",
      "Kanji": "敗"
  },
  {
      "Gakunen": "4",
      "Num": "155",
      "Kanji": "梅"
  },
  {
      "Gakunen": "4",
      "Num": "156",
      "Kanji": "博"
  },
  {
      "Gakunen": "4",
      "Num": "157",
      "Kanji": "阪"
  },
  {
      "Gakunen": "4",
      "Num": "158",
      "Kanji": "飯"
  },
  {
      "Gakunen": "4",
      "Num": "159",
      "Kanji": "飛"
  },
  {
      "Gakunen": "4",
      "Num": "160",
      "Kanji": "必"
  },
  {
      "Gakunen": "4",
      "Num": "161",
      "Kanji": "票"
  },
  {
      "Gakunen": "4",
      "Num": "162",
      "Kanji": "標"
  },
  {
      "Gakunen": "4",
      "Num": "163",
      "Kanji": "不"
  },
  {
      "Gakunen": "4",
      "Num": "164",
      "Kanji": "夫"
  },
  {
      "Gakunen": "4",
      "Num": "165",
      "Kanji": "付"
  },
  {
      "Gakunen": "4",
      "Num": "166",
      "Kanji": "府"
  },
  {
      "Gakunen": "4",
      "Num": "167",
      "Kanji": "阜"
  },
  {
      "Gakunen": "4",
      "Num": "168",
      "Kanji": "富"
  },
  {
      "Gakunen": "4",
      "Num": "169",
      "Kanji": "副"
  },
  {
      "Gakunen": "4",
      "Num": "170",
      "Kanji": "兵"
  },
  {
      "Gakunen": "4",
      "Num": "171",
      "Kanji": "別"
  },
  {
      "Gakunen": "4",
      "Num": "172",
      "Kanji": "辺"
  },
  {
      "Gakunen": "4",
      "Num": "173",
      "Kanji": "変"
  },
  {
      "Gakunen": "4",
      "Num": "174",
      "Kanji": "便"
  },
  {
      "Gakunen": "4",
      "Num": "175",
      "Kanji": "包"
  },
  {
      "Gakunen": "4",
      "Num": "176",
      "Kanji": "法"
  },
  {
      "Gakunen": "4",
      "Num": "177",
      "Kanji": "望"
  },
  {
      "Gakunen": "4",
      "Num": "178",
      "Kanji": "牧"
  },
  {
      "Gakunen": "4",
      "Num": "179",
      "Kanji": "末"
  },
  {
      "Gakunen": "4",
      "Num": "180",
      "Kanji": "満"
  },
  {
      "Gakunen": "4",
      "Num": "181",
      "Kanji": "未"
  },
  {
      "Gakunen": "4",
      "Num": "182",
      "Kanji": "民"
  },
  {
      "Gakunen": "4",
      "Num": "183",
      "Kanji": "無"
  },
  {
      "Gakunen": "4",
      "Num": "184",
      "Kanji": "約"
  },
  {
      "Gakunen": "4",
      "Num": "185",
      "Kanji": "勇"
  },
  {
      "Gakunen": "4",
      "Num": "186",
      "Kanji": "要"
  },
  {
      "Gakunen": "4",
      "Num": "187",
      "Kanji": "養"
  },
  {
      "Gakunen": "4",
      "Num": "188",
      "Kanji": "浴"
  },
  {
      "Gakunen": "4",
      "Num": "189",
      "Kanji": "利"
  },
  {
      "Gakunen": "4",
      "Num": "190",
      "Kanji": "陸"
  },
  {
      "Gakunen": "4",
      "Num": "191",
      "Kanji": "良"
  },
  {
      "Gakunen": "4",
      "Num": "192",
      "Kanji": "料"
  },
  {
      "Gakunen": "4",
      "Num": "193",
      "Kanji": "量"
  },
  {
      "Gakunen": "4",
      "Num": "194",
      "Kanji": "輪"
  },
  {
      "Gakunen": "4",
      "Num": "195",
      "Kanji": "類"
  },
  {
      "Gakunen": "4",
      "Num": "196",
      "Kanji": "令"
  },
  {
      "Gakunen": "4",
      "Num": "197",
      "Kanji": "冷"
  },
  {
      "Gakunen": "4",
      "Num": "198",
      "Kanji": "例"
  },
  {
      "Gakunen": "4",
      "Num": "199",
      "Kanji": "連"
  },
  {
      "Gakunen": "4",
      "Num": "200",
      "Kanji": "老"
  },
  {
      "Gakunen": "4",
      "Num": "201",
      "Kanji": "労"
  },
  {
      "Gakunen": "4",
      "Num": "202",
      "Kanji": "録"
  }
]

export const GO_NEN_KANJI = 
[
  {
      "Gakunen": "5",
      "Num": "1",
      "Kanji": "圧"
  },
  {
      "Gakunen": "5",
      "Num": "2",
      "Kanji": "囲"
  },
  {
      "Gakunen": "5",
      "Num": "3",
      "Kanji": "移"
  },
  {
      "Gakunen": "5",
      "Num": "4",
      "Kanji": "因"
  },
  {
      "Gakunen": "5",
      "Num": "5",
      "Kanji": "永"
  },
  {
      "Gakunen": "5",
      "Num": "6",
      "Kanji": "営"
  },
  {
      "Gakunen": "5",
      "Num": "7",
      "Kanji": "衛"
  },
  {
      "Gakunen": "5",
      "Num": "8",
      "Kanji": "易"
  },
  {
      "Gakunen": "5",
      "Num": "9",
      "Kanji": "益"
  },
  {
      "Gakunen": "5",
      "Num": "10",
      "Kanji": "液"
  },
  {
      "Gakunen": "5",
      "Num": "11",
      "Kanji": "演"
  },
  {
      "Gakunen": "5",
      "Num": "12",
      "Kanji": "応"
  },
  {
      "Gakunen": "5",
      "Num": "13",
      "Kanji": "往"
  },
  {
      "Gakunen": "5",
      "Num": "14",
      "Kanji": "桜"
  },
  {
      "Gakunen": "5",
      "Num": "15",
      "Kanji": "可"
  },
  {
      "Gakunen": "5",
      "Num": "16",
      "Kanji": "仮"
  },
  {
      "Gakunen": "5",
      "Num": "17",
      "Kanji": "価"
  },
  {
      "Gakunen": "5",
      "Num": "18",
      "Kanji": "河"
  },
  {
      "Gakunen": "5",
      "Num": "19",
      "Kanji": "過"
  },
  {
      "Gakunen": "5",
      "Num": "20",
      "Kanji": "快"
  },
  {
      "Gakunen": "5",
      "Num": "21",
      "Kanji": "解"
  },
  {
      "Gakunen": "5",
      "Num": "22",
      "Kanji": "格"
  },
  {
      "Gakunen": "5",
      "Num": "23",
      "Kanji": "確"
  },
  {
      "Gakunen": "5",
      "Num": "24",
      "Kanji": "額"
  },
  {
      "Gakunen": "5",
      "Num": "25",
      "Kanji": "刊"
  },
  {
      "Gakunen": "5",
      "Num": "26",
      "Kanji": "幹"
  },
  {
      "Gakunen": "5",
      "Num": "27",
      "Kanji": "慣"
  },
  {
      "Gakunen": "5",
      "Num": "28",
      "Kanji": "眼"
  },
  {
      "Gakunen": "5",
      "Num": "29",
      "Kanji": "紀"
  },
  {
      "Gakunen": "5",
      "Num": "30",
      "Kanji": "基"
  },
  {
      "Gakunen": "5",
      "Num": "31",
      "Kanji": "寄"
  },
  {
      "Gakunen": "5",
      "Num": "32",
      "Kanji": "規"
  },
  {
      "Gakunen": "5",
      "Num": "33",
      "Kanji": "喜"
  },
  {
      "Gakunen": "5",
      "Num": "34",
      "Kanji": "技"
  },
  {
      "Gakunen": "5",
      "Num": "35",
      "Kanji": "義"
  },
  {
      "Gakunen": "5",
      "Num": "36",
      "Kanji": "逆"
  },
  {
      "Gakunen": "5",
      "Num": "37",
      "Kanji": "久"
  },
  {
      "Gakunen": "5",
      "Num": "38",
      "Kanji": "旧"
  },
  {
      "Gakunen": "5",
      "Num": "39",
      "Kanji": "救"
  },
  {
      "Gakunen": "5",
      "Num": "40",
      "Kanji": "居"
  },
  {
      "Gakunen": "5",
      "Num": "41",
      "Kanji": "許"
  },
  {
      "Gakunen": "5",
      "Num": "42",
      "Kanji": "境"
  },
  {
      "Gakunen": "5",
      "Num": "43",
      "Kanji": "均"
  },
  {
      "Gakunen": "5",
      "Num": "44",
      "Kanji": "禁"
  },
  {
      "Gakunen": "5",
      "Num": "45",
      "Kanji": "句"
  },
  {
      "Gakunen": "5",
      "Num": "46",
      "Kanji": "型"
  },
  {
      "Gakunen": "5",
      "Num": "47",
      "Kanji": "経"
  },
  {
      "Gakunen": "5",
      "Num": "48",
      "Kanji": "潔"
  },
  {
      "Gakunen": "5",
      "Num": "49",
      "Kanji": "件"
  },
  {
      "Gakunen": "5",
      "Num": "50",
      "Kanji": "険"
  },
  {
      "Gakunen": "5",
      "Num": "51",
      "Kanji": "検"
  },
  {
      "Gakunen": "5",
      "Num": "52",
      "Kanji": "限"
  },
  {
      "Gakunen": "5",
      "Num": "53",
      "Kanji": "現"
  },
  {
      "Gakunen": "5",
      "Num": "54",
      "Kanji": "減"
  },
  {
      "Gakunen": "5",
      "Num": "55",
      "Kanji": "故"
  },
  {
      "Gakunen": "5",
      "Num": "56",
      "Kanji": "個"
  },
  {
      "Gakunen": "5",
      "Num": "57",
      "Kanji": "護"
  },
  {
      "Gakunen": "5",
      "Num": "58",
      "Kanji": "効"
  },
  {
      "Gakunen": "5",
      "Num": "59",
      "Kanji": "厚"
  },
  {
      "Gakunen": "5",
      "Num": "60",
      "Kanji": "耕"
  },
  {
      "Gakunen": "5",
      "Num": "61",
      "Kanji": "航"
  },
  {
      "Gakunen": "5",
      "Num": "62",
      "Kanji": "鉱"
  },
  {
      "Gakunen": "5",
      "Num": "63",
      "Kanji": "構"
  },
  {
      "Gakunen": "5",
      "Num": "64",
      "Kanji": "興"
  },
  {
      "Gakunen": "5",
      "Num": "65",
      "Kanji": "講"
  },
  {
      "Gakunen": "5",
      "Num": "66",
      "Kanji": "告"
  },
  {
      "Gakunen": "5",
      "Num": "67",
      "Kanji": "混"
  },
  {
      "Gakunen": "5",
      "Num": "68",
      "Kanji": "査"
  },
  {
      "Gakunen": "5",
      "Num": "69",
      "Kanji": "再"
  },
  {
      "Gakunen": "5",
      "Num": "70",
      "Kanji": "災"
  },
  {
      "Gakunen": "5",
      "Num": "71",
      "Kanji": "妻"
  },
  {
      "Gakunen": "5",
      "Num": "72",
      "Kanji": "採"
  },
  {
      "Gakunen": "5",
      "Num": "73",
      "Kanji": "際"
  },
  {
      "Gakunen": "5",
      "Num": "74",
      "Kanji": "在"
  },
  {
      "Gakunen": "5",
      "Num": "75",
      "Kanji": "財"
  },
  {
      "Gakunen": "5",
      "Num": "76",
      "Kanji": "罪"
  },
  {
      "Gakunen": "5",
      "Num": "77",
      "Kanji": "殺"
  },
  {
      "Gakunen": "5",
      "Num": "78",
      "Kanji": "雑"
  },
  {
      "Gakunen": "5",
      "Num": "79",
      "Kanji": "酸"
  },
  {
      "Gakunen": "5",
      "Num": "80",
      "Kanji": "賛"
  },
  {
      "Gakunen": "5",
      "Num": "81",
      "Kanji": "士"
  },
  {
      "Gakunen": "5",
      "Num": "82",
      "Kanji": "支"
  },
  {
      "Gakunen": "5",
      "Num": "83",
      "Kanji": "史"
  },
  {
      "Gakunen": "5",
      "Num": "84",
      "Kanji": "志"
  },
  {
      "Gakunen": "5",
      "Num": "85",
      "Kanji": "枝"
  },
  {
      "Gakunen": "5",
      "Num": "86",
      "Kanji": "師"
  },
  {
      "Gakunen": "5",
      "Num": "87",
      "Kanji": "資"
  },
  {
      "Gakunen": "5",
      "Num": "88",
      "Kanji": "飼"
  },
  {
      "Gakunen": "5",
      "Num": "89",
      "Kanji": "示"
  },
  {
      "Gakunen": "5",
      "Num": "90",
      "Kanji": "似"
  },
  {
      "Gakunen": "5",
      "Num": "91",
      "Kanji": "識"
  },
  {
      "Gakunen": "5",
      "Num": "92",
      "Kanji": "質"
  },
  {
      "Gakunen": "5",
      "Num": "93",
      "Kanji": "舎"
  },
  {
      "Gakunen": "5",
      "Num": "94",
      "Kanji": "謝"
  },
  {
      "Gakunen": "5",
      "Num": "95",
      "Kanji": "授"
  },
  {
      "Gakunen": "5",
      "Num": "96",
      "Kanji": "修"
  },
  {
      "Gakunen": "5",
      "Num": "97",
      "Kanji": "述"
  },
  {
      "Gakunen": "5",
      "Num": "98",
      "Kanji": "術"
  },
  {
      "Gakunen": "5",
      "Num": "99",
      "Kanji": "準"
  },
  {
      "Gakunen": "5",
      "Num": "100",
      "Kanji": "序"
  },
  {
      "Gakunen": "5",
      "Num": "101",
      "Kanji": "招"
  },
  {
      "Gakunen": "5",
      "Num": "102",
      "Kanji": "証"
  },
  {
      "Gakunen": "5",
      "Num": "103",
      "Kanji": "象"
  },
  {
      "Gakunen": "5",
      "Num": "104",
      "Kanji": "賞"
  },
  {
      "Gakunen": "5",
      "Num": "105",
      "Kanji": "条"
  },
  {
      "Gakunen": "5",
      "Num": "106",
      "Kanji": "状"
  },
  {
      "Gakunen": "5",
      "Num": "107",
      "Kanji": "常"
  },
  {
      "Gakunen": "5",
      "Num": "108",
      "Kanji": "情"
  },
  {
      "Gakunen": "5",
      "Num": "109",
      "Kanji": "織"
  },
  {
      "Gakunen": "5",
      "Num": "110",
      "Kanji": "職"
  },
  {
      "Gakunen": "5",
      "Num": "111",
      "Kanji": "制"
  },
  {
      "Gakunen": "5",
      "Num": "112",
      "Kanji": "性"
  },
  {
      "Gakunen": "5",
      "Num": "113",
      "Kanji": "政"
  },
  {
      "Gakunen": "5",
      "Num": "114",
      "Kanji": "勢"
  },
  {
      "Gakunen": "5",
      "Num": "115",
      "Kanji": "精"
  },
  {
      "Gakunen": "5",
      "Num": "116",
      "Kanji": "製"
  },
  {
      "Gakunen": "5",
      "Num": "117",
      "Kanji": "税"
  },
  {
      "Gakunen": "5",
      "Num": "118",
      "Kanji": "責"
  },
  {
      "Gakunen": "5",
      "Num": "119",
      "Kanji": "績"
  },
  {
      "Gakunen": "5",
      "Num": "120",
      "Kanji": "接"
  },
  {
      "Gakunen": "5",
      "Num": "121",
      "Kanji": "設"
  },
  {
      "Gakunen": "5",
      "Num": "122",
      "Kanji": "絶"
  },
  {
      "Gakunen": "5",
      "Num": "123",
      "Kanji": "祖"
  },
  {
      "Gakunen": "5",
      "Num": "124",
      "Kanji": "素"
  },
  {
      "Gakunen": "5",
      "Num": "125",
      "Kanji": "総"
  },
  {
      "Gakunen": "5",
      "Num": "126",
      "Kanji": "造"
  },
  {
      "Gakunen": "5",
      "Num": "127",
      "Kanji": "像"
  },
  {
      "Gakunen": "5",
      "Num": "128",
      "Kanji": "増"
  },
  {
      "Gakunen": "5",
      "Num": "129",
      "Kanji": "則"
  },
  {
      "Gakunen": "5",
      "Num": "130",
      "Kanji": "測"
  },
  {
      "Gakunen": "5",
      "Num": "131",
      "Kanji": "属"
  },
  {
      "Gakunen": "5",
      "Num": "132",
      "Kanji": "率"
  },
  {
      "Gakunen": "5",
      "Num": "133",
      "Kanji": "損"
  },
  {
      "Gakunen": "5",
      "Num": "134",
      "Kanji": "貸"
  },
  {
      "Gakunen": "5",
      "Num": "135",
      "Kanji": "態"
  },
  {
      "Gakunen": "5",
      "Num": "136",
      "Kanji": "団"
  },
  {
      "Gakunen": "5",
      "Num": "137",
      "Kanji": "断"
  },
  {
      "Gakunen": "5",
      "Num": "138",
      "Kanji": "築"
  },
  {
      "Gakunen": "5",
      "Num": "139",
      "Kanji": "貯"
  },
  {
      "Gakunen": "5",
      "Num": "140",
      "Kanji": "張"
  },
  {
      "Gakunen": "5",
      "Num": "141",
      "Kanji": "停"
  },
  {
      "Gakunen": "5",
      "Num": "142",
      "Kanji": "提"
  },
  {
      "Gakunen": "5",
      "Num": "143",
      "Kanji": "程"
  },
  {
      "Gakunen": "5",
      "Num": "144",
      "Kanji": "適"
  },
  {
      "Gakunen": "5",
      "Num": "145",
      "Kanji": "統"
  },
  {
      "Gakunen": "5",
      "Num": "146",
      "Kanji": "堂"
  },
  {
      "Gakunen": "5",
      "Num": "147",
      "Kanji": "銅"
  },
  {
      "Gakunen": "5",
      "Num": "148",
      "Kanji": "導"
  },
  {
      "Gakunen": "5",
      "Num": "149",
      "Kanji": "得"
  },
  {
      "Gakunen": "5",
      "Num": "150",
      "Kanji": "毒"
  },
  {
      "Gakunen": "5",
      "Num": "151",
      "Kanji": "独"
  },
  {
      "Gakunen": "5",
      "Num": "152",
      "Kanji": "任"
  },
  {
      "Gakunen": "5",
      "Num": "153",
      "Kanji": "燃"
  },
  {
      "Gakunen": "5",
      "Num": "154",
      "Kanji": "能"
  },
  {
      "Gakunen": "5",
      "Num": "155",
      "Kanji": "破"
  },
  {
      "Gakunen": "5",
      "Num": "156",
      "Kanji": "犯"
  },
  {
      "Gakunen": "5",
      "Num": "157",
      "Kanji": "判"
  },
  {
      "Gakunen": "5",
      "Num": "158",
      "Kanji": "版"
  },
  {
      "Gakunen": "5",
      "Num": "159",
      "Kanji": "比"
  },
  {
      "Gakunen": "5",
      "Num": "160",
      "Kanji": "肥"
  },
  {
      "Gakunen": "5",
      "Num": "161",
      "Kanji": "非"
  },
  {
      "Gakunen": "5",
      "Num": "162",
      "Kanji": "費"
  },
  {
      "Gakunen": "5",
      "Num": "163",
      "Kanji": "備"
  },
  {
      "Gakunen": "5",
      "Num": "164",
      "Kanji": "評"
  },
  {
      "Gakunen": "5",
      "Num": "165",
      "Kanji": "貧"
  },
  {
      "Gakunen": "5",
      "Num": "166",
      "Kanji": "布"
  },
  {
      "Gakunen": "5",
      "Num": "167",
      "Kanji": "婦"
  },
  {
      "Gakunen": "5",
      "Num": "168",
      "Kanji": "武"
  },
  {
      "Gakunen": "5",
      "Num": "169",
      "Kanji": "復"
  },
  {
      "Gakunen": "5",
      "Num": "170",
      "Kanji": "複"
  },
  {
      "Gakunen": "5",
      "Num": "171",
      "Kanji": "仏"
  },
  {
      "Gakunen": "5",
      "Num": "172",
      "Kanji": "粉"
  },
  {
      "Gakunen": "5",
      "Num": "173",
      "Kanji": "編"
  },
  {
      "Gakunen": "5",
      "Num": "174",
      "Kanji": "弁"
  },
  {
      "Gakunen": "5",
      "Num": "175",
      "Kanji": "保"
  },
  {
      "Gakunen": "5",
      "Num": "176",
      "Kanji": "墓"
  },
  {
      "Gakunen": "5",
      "Num": "177",
      "Kanji": "報"
  },
  {
      "Gakunen": "5",
      "Num": "178",
      "Kanji": "豊"
  },
  {
      "Gakunen": "5",
      "Num": "179",
      "Kanji": "防"
  },
  {
      "Gakunen": "5",
      "Num": "180",
      "Kanji": "貿"
  },
  {
      "Gakunen": "5",
      "Num": "181",
      "Kanji": "暴"
  },
  {
      "Gakunen": "5",
      "Num": "182",
      "Kanji": "脈"
  },
  {
      "Gakunen": "5",
      "Num": "183",
      "Kanji": "務"
  },
  {
      "Gakunen": "5",
      "Num": "184",
      "Kanji": "夢"
  },
  {
      "Gakunen": "5",
      "Num": "185",
      "Kanji": "迷"
  },
  {
      "Gakunen": "5",
      "Num": "186",
      "Kanji": "綿"
  },
  {
      "Gakunen": "5",
      "Num": "187",
      "Kanji": "輸"
  },
  {
      "Gakunen": "5",
      "Num": "188",
      "Kanji": "余"
  },
  {
      "Gakunen": "5",
      "Num": "189",
      "Kanji": "容"
  },
  {
      "Gakunen": "5",
      "Num": "190",
      "Kanji": "略"
  },
  {
      "Gakunen": "5",
      "Num": "191",
      "Kanji": "留"
  },
  {
      "Gakunen": "5",
      "Num": "192",
      "Kanji": "領"
  },
  {
      "Gakunen": "5",
      "Num": "193",
      "Kanji": "歴"
  }
]

export const ROKU_NEN_KANJI = 
[
  {
      "Gakunen": "6",
      "Num": "1",
      "Kanji": "胃"
  },
  {
      "Gakunen": "6",
      "Num": "2",
      "Kanji": "異"
  },
  {
      "Gakunen": "6",
      "Num": "3",
      "Kanji": "遺"
  },
  {
      "Gakunen": "6",
      "Num": "4",
      "Kanji": "域"
  },
  {
      "Gakunen": "6",
      "Num": "5",
      "Kanji": "宇"
  },
  {
      "Gakunen": "6",
      "Num": "6",
      "Kanji": "映"
  },
  {
      "Gakunen": "6",
      "Num": "7",
      "Kanji": "延"
  },
  {
      "Gakunen": "6",
      "Num": "8",
      "Kanji": "沿"
  },
  {
      "Gakunen": "6",
      "Num": "9",
      "Kanji": "恩"
  },
  {
      "Gakunen": "6",
      "Num": "10",
      "Kanji": "我"
  },
  {
      "Gakunen": "6",
      "Num": "11",
      "Kanji": "灰"
  },
  {
      "Gakunen": "6",
      "Num": "12",
      "Kanji": "拡"
  },
  {
      "Gakunen": "6",
      "Num": "13",
      "Kanji": "革"
  },
  {
      "Gakunen": "6",
      "Num": "14",
      "Kanji": "閣"
  },
  {
      "Gakunen": "6",
      "Num": "15",
      "Kanji": "割"
  },
  {
      "Gakunen": "6",
      "Num": "16",
      "Kanji": "株"
  },
  {
      "Gakunen": "6",
      "Num": "17",
      "Kanji": "干"
  },
  {
      "Gakunen": "6",
      "Num": "18",
      "Kanji": "巻"
  },
  {
      "Gakunen": "6",
      "Num": "19",
      "Kanji": "看"
  },
  {
      "Gakunen": "6",
      "Num": "20",
      "Kanji": "簡"
  },
  {
      "Gakunen": "6",
      "Num": "21",
      "Kanji": "危"
  },
  {
      "Gakunen": "6",
      "Num": "22",
      "Kanji": "机"
  },
  {
      "Gakunen": "6",
      "Num": "23",
      "Kanji": "揮"
  },
  {
      "Gakunen": "6",
      "Num": "24",
      "Kanji": "貴"
  },
  {
      "Gakunen": "6",
      "Num": "25",
      "Kanji": "疑"
  },
  {
      "Gakunen": "6",
      "Num": "26",
      "Kanji": "吸"
  },
  {
      "Gakunen": "6",
      "Num": "27",
      "Kanji": "供"
  },
  {
      "Gakunen": "6",
      "Num": "28",
      "Kanji": "胸"
  },
  {
      "Gakunen": "6",
      "Num": "29",
      "Kanji": "郷"
  },
  {
      "Gakunen": "6",
      "Num": "30",
      "Kanji": "勤"
  },
  {
      "Gakunen": "6",
      "Num": "31",
      "Kanji": "筋"
  },
  {
      "Gakunen": "6",
      "Num": "32",
      "Kanji": "系"
  },
  {
      "Gakunen": "6",
      "Num": "33",
      "Kanji": "敬"
  },
  {
      "Gakunen": "6",
      "Num": "34",
      "Kanji": "警"
  },
  {
      "Gakunen": "6",
      "Num": "35",
      "Kanji": "劇"
  },
  {
      "Gakunen": "6",
      "Num": "36",
      "Kanji": "激"
  },
  {
      "Gakunen": "6",
      "Num": "37",
      "Kanji": "穴"
  },
  {
      "Gakunen": "6",
      "Num": "38",
      "Kanji": "券"
  },
  {
      "Gakunen": "6",
      "Num": "39",
      "Kanji": "絹"
  },
  {
      "Gakunen": "6",
      "Num": "40",
      "Kanji": "権"
  },
  {
      "Gakunen": "6",
      "Num": "41",
      "Kanji": "憲"
  },
  {
      "Gakunen": "6",
      "Num": "42",
      "Kanji": "源"
  },
  {
      "Gakunen": "6",
      "Num": "43",
      "Kanji": "厳"
  },
  {
      "Gakunen": "6",
      "Num": "44",
      "Kanji": "己"
  },
  {
      "Gakunen": "6",
      "Num": "45",
      "Kanji": "呼"
  },
  {
      "Gakunen": "6",
      "Num": "46",
      "Kanji": "誤"
  },
  {
      "Gakunen": "6",
      "Num": "47",
      "Kanji": "后"
  },
  {
      "Gakunen": "6",
      "Num": "48",
      "Kanji": "孝"
  },
  {
      "Gakunen": "6",
      "Num": "49",
      "Kanji": "皇"
  },
  {
      "Gakunen": "6",
      "Num": "50",
      "Kanji": "紅"
  },
  {
      "Gakunen": "6",
      "Num": "51",
      "Kanji": "降"
  },
  {
      "Gakunen": "6",
      "Num": "52",
      "Kanji": "鋼"
  },
  {
      "Gakunen": "6",
      "Num": "53",
      "Kanji": "刻"
  },
  {
      "Gakunen": "6",
      "Num": "54",
      "Kanji": "穀"
  },
  {
      "Gakunen": "6",
      "Num": "55",
      "Kanji": "骨"
  },
  {
      "Gakunen": "6",
      "Num": "56",
      "Kanji": "困"
  },
  {
      "Gakunen": "6",
      "Num": "57",
      "Kanji": "砂"
  },
  {
      "Gakunen": "6",
      "Num": "58",
      "Kanji": "座"
  },
  {
      "Gakunen": "6",
      "Num": "59",
      "Kanji": "済"
  },
  {
      "Gakunen": "6",
      "Num": "60",
      "Kanji": "裁"
  },
  {
      "Gakunen": "6",
      "Num": "61",
      "Kanji": "策"
  },
  {
      "Gakunen": "6",
      "Num": "62",
      "Kanji": "冊"
  },
  {
      "Gakunen": "6",
      "Num": "63",
      "Kanji": "蚕"
  },
  {
      "Gakunen": "6",
      "Num": "64",
      "Kanji": "至"
  },
  {
      "Gakunen": "6",
      "Num": "65",
      "Kanji": "私"
  },
  {
      "Gakunen": "6",
      "Num": "66",
      "Kanji": "姿"
  },
  {
      "Gakunen": "6",
      "Num": "67",
      "Kanji": "視"
  },
  {
      "Gakunen": "6",
      "Num": "68",
      "Kanji": "詞"
  },
  {
      "Gakunen": "6",
      "Num": "69",
      "Kanji": "誌"
  },
  {
      "Gakunen": "6",
      "Num": "70",
      "Kanji": "磁"
  },
  {
      "Gakunen": "6",
      "Num": "71",
      "Kanji": "射"
  },
  {
      "Gakunen": "6",
      "Num": "72",
      "Kanji": "捨"
  },
  {
      "Gakunen": "6",
      "Num": "73",
      "Kanji": "尺"
  },
  {
      "Gakunen": "6",
      "Num": "74",
      "Kanji": "若"
  },
  {
      "Gakunen": "6",
      "Num": "75",
      "Kanji": "樹"
  },
  {
      "Gakunen": "6",
      "Num": "76",
      "Kanji": "収"
  },
  {
      "Gakunen": "6",
      "Num": "77",
      "Kanji": "宗"
  },
  {
      "Gakunen": "6",
      "Num": "78",
      "Kanji": "就"
  },
  {
      "Gakunen": "6",
      "Num": "79",
      "Kanji": "衆"
  },
  {
      "Gakunen": "6",
      "Num": "80",
      "Kanji": "従"
  },
  {
      "Gakunen": "6",
      "Num": "81",
      "Kanji": "縦"
  },
  {
      "Gakunen": "6",
      "Num": "82",
      "Kanji": "縮"
  },
  {
      "Gakunen": "6",
      "Num": "83",
      "Kanji": "熟"
  },
  {
      "Gakunen": "6",
      "Num": "84",
      "Kanji": "純"
  },
  {
      "Gakunen": "6",
      "Num": "85",
      "Kanji": "処"
  },
  {
      "Gakunen": "6",
      "Num": "86",
      "Kanji": "署"
  },
  {
      "Gakunen": "6",
      "Num": "87",
      "Kanji": "諸"
  },
  {
      "Gakunen": "6",
      "Num": "88",
      "Kanji": "除"
  },
  {
      "Gakunen": "6",
      "Num": "89",
      "Kanji": "承"
  },
  {
      "Gakunen": "6",
      "Num": "90",
      "Kanji": "将"
  },
  {
      "Gakunen": "6",
      "Num": "91",
      "Kanji": "傷"
  },
  {
      "Gakunen": "6",
      "Num": "92",
      "Kanji": "障"
  },
  {
      "Gakunen": "6",
      "Num": "93",
      "Kanji": "蒸"
  },
  {
      "Gakunen": "6",
      "Num": "94",
      "Kanji": "針"
  },
  {
      "Gakunen": "6",
      "Num": "95",
      "Kanji": "仁"
  },
  {
      "Gakunen": "6",
      "Num": "96",
      "Kanji": "垂"
  },
  {
      "Gakunen": "6",
      "Num": "97",
      "Kanji": "推"
  },
  {
      "Gakunen": "6",
      "Num": "98",
      "Kanji": "寸"
  },
  {
      "Gakunen": "6",
      "Num": "99",
      "Kanji": "盛"
  },
  {
      "Gakunen": "6",
      "Num": "100",
      "Kanji": "聖"
  },
  {
      "Gakunen": "6",
      "Num": "101",
      "Kanji": "誠"
  },
  {
      "Gakunen": "6",
      "Num": "102",
      "Kanji": "舌"
  },
  {
      "Gakunen": "6",
      "Num": "103",
      "Kanji": "宣"
  },
  {
      "Gakunen": "6",
      "Num": "104",
      "Kanji": "専"
  },
  {
      "Gakunen": "6",
      "Num": "105",
      "Kanji": "泉"
  },
  {
      "Gakunen": "6",
      "Num": "106",
      "Kanji": "洗"
  },
  {
      "Gakunen": "6",
      "Num": "107",
      "Kanji": "染"
  },
  {
      "Gakunen": "6",
      "Num": "108",
      "Kanji": "銭"
  },
  {
      "Gakunen": "6",
      "Num": "109",
      "Kanji": "善"
  },
  {
      "Gakunen": "6",
      "Num": "110",
      "Kanji": "奏"
  },
  {
      "Gakunen": "6",
      "Num": "111",
      "Kanji": "窓"
  },
  {
      "Gakunen": "6",
      "Num": "112",
      "Kanji": "創"
  },
  {
      "Gakunen": "6",
      "Num": "113",
      "Kanji": "装"
  },
  {
      "Gakunen": "6",
      "Num": "114",
      "Kanji": "層"
  },
  {
      "Gakunen": "6",
      "Num": "115",
      "Kanji": "操"
  },
  {
      "Gakunen": "6",
      "Num": "116",
      "Kanji": "蔵"
  },
  {
      "Gakunen": "6",
      "Num": "117",
      "Kanji": "臓"
  },
  {
      "Gakunen": "6",
      "Num": "118",
      "Kanji": "存"
  },
  {
      "Gakunen": "6",
      "Num": "119",
      "Kanji": "尊"
  },
  {
      "Gakunen": "6",
      "Num": "120",
      "Kanji": "退"
  },
  {
      "Gakunen": "6",
      "Num": "121",
      "Kanji": "宅"
  },
  {
      "Gakunen": "6",
      "Num": "122",
      "Kanji": "担"
  },
  {
      "Gakunen": "6",
      "Num": "123",
      "Kanji": "探"
  },
  {
      "Gakunen": "6",
      "Num": "124",
      "Kanji": "誕"
  },
  {
      "Gakunen": "6",
      "Num": "125",
      "Kanji": "段"
  },
  {
      "Gakunen": "6",
      "Num": "126",
      "Kanji": "暖"
  },
  {
      "Gakunen": "6",
      "Num": "127",
      "Kanji": "値"
  },
  {
      "Gakunen": "6",
      "Num": "128",
      "Kanji": "宙"
  },
  {
      "Gakunen": "6",
      "Num": "129",
      "Kanji": "忠"
  },
  {
      "Gakunen": "6",
      "Num": "130",
      "Kanji": "著"
  },
  {
      "Gakunen": "6",
      "Num": "131",
      "Kanji": "庁"
  },
  {
      "Gakunen": "6",
      "Num": "132",
      "Kanji": "頂"
  },
  {
      "Gakunen": "6",
      "Num": "133",
      "Kanji": "腸"
  },
  {
      "Gakunen": "6",
      "Num": "134",
      "Kanji": "潮"
  },
  {
      "Gakunen": "6",
      "Num": "135",
      "Kanji": "賃"
  },
  {
      "Gakunen": "6",
      "Num": "136",
      "Kanji": "痛"
  },
  {
      "Gakunen": "6",
      "Num": "137",
      "Kanji": "敵"
  },
  {
      "Gakunen": "6",
      "Num": "138",
      "Kanji": "展"
  },
  {
      "Gakunen": "6",
      "Num": "139",
      "Kanji": "討"
  },
  {
      "Gakunen": "6",
      "Num": "140",
      "Kanji": "党"
  },
  {
      "Gakunen": "6",
      "Num": "141",
      "Kanji": "糖"
  },
  {
      "Gakunen": "6",
      "Num": "142",
      "Kanji": "届"
  },
  {
      "Gakunen": "6",
      "Num": "143",
      "Kanji": "難"
  },
  {
      "Gakunen": "6",
      "Num": "144",
      "Kanji": "乳"
  },
  {
      "Gakunen": "6",
      "Num": "145",
      "Kanji": "認"
  },
  {
      "Gakunen": "6",
      "Num": "146",
      "Kanji": "納"
  },
  {
      "Gakunen": "6",
      "Num": "147",
      "Kanji": "脳"
  },
  {
      "Gakunen": "6",
      "Num": "148",
      "Kanji": "派"
  },
  {
      "Gakunen": "6",
      "Num": "149",
      "Kanji": "拝"
  },
  {
      "Gakunen": "6",
      "Num": "150",
      "Kanji": "背"
  },
  {
      "Gakunen": "6",
      "Num": "151",
      "Kanji": "肺"
  },
  {
      "Gakunen": "6",
      "Num": "152",
      "Kanji": "俳"
  },
  {
      "Gakunen": "6",
      "Num": "153",
      "Kanji": "班"
  },
  {
      "Gakunen": "6",
      "Num": "154",
      "Kanji": "晩"
  },
  {
      "Gakunen": "6",
      "Num": "155",
      "Kanji": "否"
  },
  {
      "Gakunen": "6",
      "Num": "156",
      "Kanji": "批"
  },
  {
      "Gakunen": "6",
      "Num": "157",
      "Kanji": "秘"
  },
  {
      "Gakunen": "6",
      "Num": "158",
      "Kanji": "俵"
  },
  {
      "Gakunen": "6",
      "Num": "159",
      "Kanji": "腹"
  },
  {
      "Gakunen": "6",
      "Num": "160",
      "Kanji": "奮"
  },
  {
      "Gakunen": "6",
      "Num": "161",
      "Kanji": "並"
  },
  {
      "Gakunen": "6",
      "Num": "162",
      "Kanji": "陛"
  },
  {
      "Gakunen": "6",
      "Num": "163",
      "Kanji": "閉"
  },
  {
      "Gakunen": "6",
      "Num": "164",
      "Kanji": "片"
  },
  {
      "Gakunen": "6",
      "Num": "165",
      "Kanji": "補"
  },
  {
      "Gakunen": "6",
      "Num": "166",
      "Kanji": "暮"
  },
  {
      "Gakunen": "6",
      "Num": "167",
      "Kanji": "宝"
  },
  {
      "Gakunen": "6",
      "Num": "168",
      "Kanji": "訪"
  },
  {
      "Gakunen": "6",
      "Num": "169",
      "Kanji": "亡"
  },
  {
      "Gakunen": "6",
      "Num": "170",
      "Kanji": "忘"
  },
  {
      "Gakunen": "6",
      "Num": "171",
      "Kanji": "棒"
  },
  {
      "Gakunen": "6",
      "Num": "172",
      "Kanji": "枚"
  },
  {
      "Gakunen": "6",
      "Num": "173",
      "Kanji": "幕"
  },
  {
      "Gakunen": "6",
      "Num": "174",
      "Kanji": "密"
  },
  {
      "Gakunen": "6",
      "Num": "175",
      "Kanji": "盟"
  },
  {
      "Gakunen": "6",
      "Num": "176",
      "Kanji": "模"
  },
  {
      "Gakunen": "6",
      "Num": "177",
      "Kanji": "訳"
  },
  {
      "Gakunen": "6",
      "Num": "178",
      "Kanji": "郵"
  },
  {
      "Gakunen": "6",
      "Num": "179",
      "Kanji": "優"
  },
  {
      "Gakunen": "6",
      "Num": "180",
      "Kanji": "預"
  },
  {
      "Gakunen": "6",
      "Num": "181",
      "Kanji": "幼"
  },
  {
      "Gakunen": "6",
      "Num": "182",
      "Kanji": "欲"
  },
  {
      "Gakunen": "6",
      "Num": "183",
      "Kanji": "翌"
  },
  {
      "Gakunen": "6",
      "Num": "184",
      "Kanji": "乱"
  },
  {
      "Gakunen": "6",
      "Num": "185",
      "Kanji": "卵"
  },
  {
      "Gakunen": "6",
      "Num": "186",
      "Kanji": "覧"
  },
  {
      "Gakunen": "6",
      "Num": "187",
      "Kanji": "裏"
  },
  {
      "Gakunen": "6",
      "Num": "188",
      "Kanji": "律"
  },
  {
      "Gakunen": "6",
      "Num": "189",
      "Kanji": "臨"
  },
  {
      "Gakunen": "6",
      "Num": "190",
      "Kanji": "朗"
  },
  {
      "Gakunen": "6",
      "Num": "191",
      "Kanji": "論"
  }
]
